var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"welcome"}},[_c('v-container',[_c('v-sheet',{staticClass:"welcome-card",attrs:{"opacity":"2"}},[_c('p',{staticClass:"subtitle mt-2 px-3"},[_vm._v("Please select the language below. ")]),_c('loc-sw')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }